<template>
  <div class="bind-page">
    <div class="bind-header">
      <p>用户编号查询</p>
    </div>
    <div class="business">
          <div class="toggletab" :class="[currentIndex == 0 ? 'activeleft' : 'activeright']">
            <van-tabs v-model="currentIndex" @click="resetSearch">
                <van-tab v-for="(item, index) in list" :key="index" :title="item.name">
                </van-tab>
            </van-tabs>
          </div>
    </div>
    <div class="bind-content" id="bind">
      <van-form>
        <van-cell-group>
          <p>{{ list[currentIndex].name }} ：</p>
          <van-field
            :label="list[currentIndex].name"
            :placeholder="'请输入' + list[currentIndex].name"
            center
            v-model="searchVal"
          >
            <!-- <template #button>
              <van-button
                size="mini"
                type="default"
                class="sms-button"
                @click="onBlur"
                :disabled="!searchVal"
              >
                查询
              </van-button>
            </template> -->
          </van-field>

        </van-cell-group>
        <div class="submit-button">
          <van-button
            block
            type="info"
            @click="onBlur"
            :disabled="!searchVal"
          >
            查询户号
          </van-button>
        </div>
      </van-form>
      <van-popup
      v-model="showClient"
      round
      :closeable="false"
      position="bottom"
      :style="{ height: '60%' }"
    >
      <div class="popup-content">
        <div class="title">
          <p>选择户号</p>
        </div>
        <div class="content">
          <div class="email-list" v-if="unBindData.length">
            <ul>
              <li
                v-for="(item, index) in unBindData"
                :key="index"
                @click="chooseClient = item.clientCode"
              >
                <van-field label="户号" v-model="item.clientCode" readonly label-width="50px">
                  <template #button>
                    <van-checkbox v-model="item.isChoose" />
                  </template>
                </van-field>
              </li>
            </ul>
          </div>
          <div class="btn">
            <van-button
              type="default"
              class="cancelBtn"
              @click="showClient = false"
            >
              取消
            </van-button>
            <van-button type="info" class="sendBtn" @click="toBindClient"
              >去绑定</van-button
            >
          </div>
        </div>
      </div>
    </van-popup>
    </div>
  </div>
</template>

<script>
import scan from "../../assets/icon/scan@2x.png";
import invertedTriangle from "../../assets/icon/invertedTriangle@2x.png";
import pic_userNoExample from "../../assets/background/pic_userNoExample.png";
import { isMobile, identityId, checkName } from "@/utils/validator";
import {
  bindClient,
  selectWaterUserDetails,
  selectWaterUserParams,
  getImageCode,
  getPhoneCode,
  checkedCode,
  selectClientNO,
} from "../../api/user";
import store from "@/store";
import axios from "axios";
import { Toast } from "vant";

export default {
  name: "Bind",
  data() {
    return {
      list: [
        {
          name: "水表号",
          value: '1'
        },
        {
          name: "身份证",
          value: '2'
        },
        // {
        //   name: "手机号",
        //   value: '3'
        // },
      ],
      currentIndex: 0,
      searchVal: "",

      dataInfoFlag: true,
      unBindData: [],
      isMultiple: false, // 是否多选
      bindloading: false,
      clientLists: [],
      showClient: false,
      chooseClient: undefined
    };
  },
  mounted() {
    this.searchClientInfo = {};
  },
  methods: {
    toBindClient() {
      this.$router.push({
        path: '/Bind/selectBindAccount',
        name: "SelectBindAccount",
        query: {
          clientCode: this.chooseClient
        }
      });
    },
    validatorPhone(val) {
      return isMobile(val);
    },
    resetSearch() {
      this.searchVal = "";
      this.chooseClient = undefined;
      if (this.currentIndex === 1) {
        this.searchVal = store.state.user.mobile;
      }
    },
    async onBlur() {
      this.unBindData = [];
      this.showClient = false;
      if (this.currentIndex === 0 && this.searchVal) {
        const {
          status,
          resultData,
          errorMessage,
        } = await selectClientNO({meterCode : this.searchVal});
        if (resultData ) {
          this.showClient = true;
          this.unBindData = [resultData].map((item, index)=> {
            return {
              clientCode: item,
              isChoose: index==0? true: false
            }
          })
          this.chooseClient = resultData;
        } else {
          Toast.fail(errorMessage);
        }
      } else {
        let param = {
          clientIdNum: this.currentIndex === 1 ? this.searchVal:'',
          clientCode: '',
          clientPhone: this.currentIndex === 2 ? this.searchVal:'',
        }
        const {
          status,
          resultData,
          errorMessage,
        } = await selectWaterUserParams(param);
        if (resultData ) {
          this.showClient = true;
          this.unBindData = resultData.map((item, index) => {
            return {
              ...item,
              clientCode: item.clientCode,
              isChoose: index==0? true: false
            }
          })
          this.chooseClient = resultData[0].clientCode;
        } else {
          Toast.fail(errorMessage);
        }
      }
    },
    
    // 通过身份证/手机号绑定页面
    goToUserInfoBind() {
      this.$router.push({
        path: "/Bind/householderInfo",
      });
    },
    changeVal(e) {
      if (this.currentIndex === 1) {
        let reg = /^(((\d{3,4}-)?[0-9]{7,8})|(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8})$/;
        if (!reg.test(e)) {
          return Toast.fail("手机号不存在，请重新输入手机号");
        }
      }
      if (this.currentIndex === 2) {
        let reg = /^[0-9Xx]*$/;
        if (!reg.test(e)) {
          return Toast.fail("身份证号不存在，请重新输入身份证号");
        }
      }
    },
    // 提交
    async onSubmit() {
      let phone = this.actPhone || this.phoneNum;
      let reg = /^(((\d{3,4}-)?[0-9]{7,8})|(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8})$/;
      if (!reg.test(phone)) {
        return Toast.fail("手机号不存在，请重新输入手机号");
      }
      if (!this.verificationCode) {
        Toast.fail("验证码不能为空");
        return;
      }
      let data ;
      if (data.status === "complete") {
        this.$router.push({
          path: "/Bind/selectBindAccount",
          name: "SelectBindAccount",
          query: {
            clientCode: this.searchClientInfo.clientCode,
            phone: this.searchClientInfo.clientPhone,
            clientIdNumber: this.searchClientInfo.clientIdNumber,
          },
        });
      } else {
        let message = data.errorMessage || "验证码错误，请重新验证！";
        Toast.fail(message);
        return;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.bind-page {
  overflow-x: hidden;
  background-color: #ffffff;
  .bind-header {
    display: flex;
    margin-top: 33px;
    padding-left: 16px;
    text-align: left;
    height: 66px;
    p {
      font-family: PingFangSC-Medium;
      font-size: 24px;
      color: #1c2734;
      line-height: 26px;
      margin: 0px;
    }
    span {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      line-height: 26px;
      margin-bottom: 36px;
      padding-top: 2px;
      margin-right: 20px;
      flex: 1;
      text-align: end;
    }
  }
  .bind-content {
    display: inline-block;
    width: 90%;
    margin: 10px 20px 15px 20px;
    /deep/.van-cell__title {
      span {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #333333;
      }
    }
    /deep/.van-field__control {
      display: inline-block;
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #000;
      font-weight: 800;
      height: 44px;
      background-color: #eee;
      padding-left: 12px;
      border-radius: 10px;
    }
    .error-input {
      /deep/.van-field__control {
        color: red;
      }
    }
    /deep/.van-field__right-icon {
      font-size: 16px;
    }
    /deep/.van-field__label {
      margin-right: 0px;
      display: none;
    }
    ::-webkit-input-placeholder {
      /* WebKit, Blink, Edge */
      color: #cccccc;
      font-size: 16px;
    }
    .submit-button {
      border-radius: 10px;
      margin: 32px 1px 0px;
      margin-bottom: 60px;
      p {
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #999999;
        text-align: center;
        line-height: 17px;
        margin-top: 12px;
        em {
          font-style: normal;
        }
      }
      .van-button__text {
        font-family: PingFangSC-Regular;
        font-size: 18px;
        color: #ffffff;
        text-align: center;
      }
      .van-button {
        border-radius: 10px;
      }
    }
    .sms-button {
      border-radius: 4px;
      width: 90px;
      background: #1989fa;
      color: #fff;
      height: 44px;
      font-size: 16px;
    }
  }
  /deep/.van-cell {
    margin-top: 20px;
    padding: 0;
  }
}

.business {
  padding: 0;
  box-shadow: 0 6px 6px 0 #3333330d;
  background: #f5f7f9;
  overflow: hidden;
  border-radius: 10px;
  width: 90%;
  margin: 0 auto;

  .title-item {
    color: #fff;
  }

  &-item {
    color: #666;
    font-size: 14px;
    line-height: 20px;

    &:nth-child(-n + 3) {
      margin-bottom: 20px;
    }

    img {
      width: 25px;
      height: 25px;
      margin-bottom: 12px;
    }

    .water {
      width: 21px;
      height: 26px;
    }
  }

  /deep/ .van-grid-item__content {
    padding: 0;
    margin-bottom: 12px;
  }
}

.van-tabs {
  .van-tabs__wrap {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
}

/deep/.van-tabs__nav {
  background-color: transparent;

  .van-tab {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 16px;
    color: #666666;
  }

  .van-tab--active {
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 16px;
    color: #fff;
    text-align: center;
    background: #1989fa;
    border-radius: 20px;
  }
}

/deep/.van-tabs__line {
  background-color: transparent;
}

.van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
  border-width: 0;
}

.popup-content {
    .title {
      border-bottom: 1px solid #eeeeee;
      padding-top: 12px;
      padding-bottom: 12px;
      p {
        font-family: PingFangSC-Medium;
        font-size: 18px;
        color: #333333;
        text-align: center;
        line-height: 26px;
        margin: 0px;
      }
    }
    .content {
      /deep/.van-field__control {
        height: 45px;
        background-color: #f9f8f8;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.65);
        letter-spacing: 0;
        text-indent: 1em;
      }
      .btn {
        margin-left: 16px;
        margin-right: 16px;
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
        .cancelBtn {
          width: 125px;
          height: 44px;
          border-radius: 4px;
          background: #f6f6f6;
          color: #4285f4;
        }
        .sendBtn {
          width: 125px;
          height: 44px;
          border-radius: 4px;
        }
      }
      .email-list {
        margin: 16px;
        max-height: 200px;
        // overflow-y: scroll;
        ul {
          li {
            height: 28px;
            line-height: 28px;
          }
        }
      }
    }
  }
</style>
